import { Modal } from "antd";
import DashboardFilters from "../DashboardFilters";
import AuditFormEdit from "../../../views/qms/auditForms/auditFormEdit";

export default function TopContainerHeader(props) {
  const {
    sectionTitle,
    sectionDescription,
    hasSectionButton,
    sectionButtons,
    hasFilter,
    FormComponent,
    formTitle,
    modalOpen,
    setModalOpen,
    formProps,
    filters = {},
  } = props;

  return (
    <div className="sectionTitle">
      <div className="sectionTitleWrap">
        <div className="sectionTitleCol titleContent">
          <h2>{sectionTitle}</h2>
          {sectionDescription && (
            <p className="smallLightText mb-0">
              {typeof sectionDescription === "string" ? (
                <span
                  dangerouslySetInnerHTML={{ __html: sectionDescription }}
                />
              ) : (
                sectionDescription
              )}
            </p>
          )}
        </div>
        <div className="sectionTitleCol">
          {hasSectionButton && (
            <div className="titleButtons">
              {sectionButtons &&
                sectionButtons?.map((item, index) => {
                  if (item.isVisible && item.itemType === "downloadAsExcel") {
                    return item.renderComponent;
                  }
                  return (
                    item.isVisible && (
                      <button
                        key={item.key || index}
                        type="button"
                        className={`defaultBtn ${item.itemClassName}`}
                        onClick={() => {
                          item.onClick && item.onClick();
                        }}
                      >
                        {item?.itemIcon && (
                          <i className="btnIcon">{item.itemIcon}</i>
                        )}
                        {item?.itemType === "add" && <i>+</i>}
                        {item?.itemName}
                      </button>
                    )
                  );
                })}
            </div>
          )}
        </div>
      </div>

      {hasFilter && (
        <DashboardFilters
          clients={filters?.clients || []}
          agents={filters?.agents || []}
          tls={filters?.tls || []}
          departments={filters?.departments || []}
          auditForms={filters?.auditForms || []}
          auditors={filters?.auditors || []}
          selectedClients={filters?.selectedClients || []}
          selectedAgents={filters?.selectedAgents || []}
          selectedDepartments={filters?.selectedDepartments || []}
          selectedAuditForms={filters?.selectedAuditForms || []}
          roleHierarchyUsers={filters?.roleHierarchyUsers || []}
          isValid={filters?.isValid}
          onFilterChange={filters?.onFilterChange}
          onSubmit={filters?.onSubmit}
        />
      )}

      {/*Dynamic Modal Rendered Inside Header */}
      {setModalOpen && (
        <Modal
          title={formTitle}
          open={modalOpen}
          onCancel={() => setModalOpen(false)}
          footer={null}
          destroyOnClose
        >
          {formTitle === "Edit Audit Form" ? (
            <AuditFormEdit
              editRecord={formProps?.editData}
              routeState={formProps?.editRouteState}
              processes={formProps?.processes}
              onSuccess={formProps?.onSuccess}
            />
          ) : (
            <FormComponent
              {...formProps}
              onSuccess={(...args) => {
                formProps?.onSuccess?.(...args);
                setModalOpen(false);
              }}
            />
          )}
        </Modal>
      )}
    </div>
  );
}
